import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import '../MoneyTransferComponent/TransactionList.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import FinxPayLogo from "../../assests/images/finxpay.png";
import { v4 as uuidv4 } from 'uuid';
import Pagination from "react-js-pagination";
import { store } from "../../redux/store";
import { setTxnHistoryElementNo, setTxnHistoryResponse, setTxnReportingData, setTxnHistoryPaginationResponse } from '../../redux/misc-data/misc-data.action';
import { setFilterEndDate, setFilterStartDate, setRechargeType } from "../../redux/recharge/recharge.action";
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import DatePicker from 'react-datepicker';
import './react-datepicker.css'
import { AccountHistoryModal } from "../Exportcomponent/AccountHistoryModal";
import './accountHistory.css';

import $ from 'jquery';
const httpClient = axios.create();


class AccountHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            fromDate: new Date(),
            toDate: new Date(),
            pageNo: 0,
            orderResp: [],
            activePage: 1,
            totalElements: '',
            totalPages: '',
            totalPageModalList: [],
            showExportModal: '',
            pagenoToExport: '',
            showModalVal: '',
            exportArr: [],
            pageNoOnExport: 0,
            exportCompleted: '',
            pageNoselected: '',
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),

        }
    }


    handlePageChangeDefault(pageNumber) {
        this.setState({
            activePage: pageNumber
        })

        console.log(pageNumber);

        this.loadTxnHistory((pageNumber - 1), this.state.fromDate, this.state.toDate, false);

    }

    componentDidMount = () => {

        // this.handlePageChangeDefault(0);

    }


    loadTxnHistory(pageNo, startDate, endDate, forExport) {
        console.log('calling for..pageno:' + pageNo + ':startDate:' +
            startDate + ':endDate:' + endDate + ':export-enable:' + forExport);

        if (startDate != '' && endDate != ''
            && startDate != endDate) {
            var url = '';

            this.setState({
                errorMessage: '',
                contentLoading: true,
                orderResp: [],
                totalElements: '',
                totalPages: ''
            })

            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            url = '/api/v1/account/history';

            // Begin assigning parameters
            var param = {
                entity: this.props.agentInfo.id,
                page: pageNo,
                from: moment(startDate).format('YYYY-MM-DD'),
                to: moment(endDate).format('YYYY-MM-DD')
            }
            httpClient.get(url, {
                params: param,
                timeout: 60 * 1000,
                timeoutErrorMessage: 'timeout',
                headers
            }
            ).then((response) => {
                this.setState({
                    contentLoading: false
                })
                console.log('order response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    var totalPageArrList = [];
                    this.setState({
                        orderResp: response.data.history,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages
                    })


                    // response.data.totalPages = 100;



                    if (response.data.totalPages > 0) {
                        for (let i = 1; i <= response.data.totalPages; i++) {
                            totalPageArrList.push(i);
                        }
                    }
                    this.setState({
                        totalPageModalList: totalPageArrList
                    })


                } else {
                    if (response.data.displayMsg = 'No more than 14 days of history is allowed') {
                        this.setState({
                            contentLoading: false,
                            errorMessage: 'No more than 14 days of history is allowed'
                        })
                    }
                }

            }).catch(error => {

                this.setState({
                    contentLoading: false,
                    errorMessage: 'Something went wrong!'
                })




                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                }

            })
        } else {
            // if(startDate==endDate){
            //     errorMessage: 'Somethingwent wrong!'
            // }
        }
    }

    exportTxnHistory(pageNo, startDate, endDate, forExport) {
        console.log('calling for..pageno:' + pageNo + ':startDate:' +
            startDate + ':endDate:' + endDate + ':export-enable:' + forExport);

        if (startDate != '' && endDate != ''
            && startDate != endDate) {
            var url = '';

            this.setState({
                errorMessage: '',
            })

            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            url = '/api/v1/account/history';

            // Begin assigning parameters
            var param = {
                entity: this.props.agentInfo.id,
                page: pageNo,
                from: moment(startDate).format('YYYY-MM-DD'),
                to: moment(endDate).format('YYYY-MM-DD')
            }
            httpClient.get(url, {
                params: param,
                timeout: 60 * 1000,
                timeoutErrorMessage: 'timeout',
                headers
            }
            ).then((response) => {

                console.log('order response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    this.state.pageNoOnExport++;

                    console.log('total Elements before :' + this.state.exportArr.length);
                    var totalDataForExport = this.state.exportArr;


                    if (forExport == true) {

                        response.data.history.map(res => {
                            var exportDta = {
                                id: res.id,
                                entityId: res.entityId,
                                type: res.type,
                                subType: res.subType,
                                amount: res.amount,
                                balanceBefore: res.balanceBefore,
                                balanceAfter: res.balanceAfter,
                                refId: res.refId,
                                reversalRef: res.reversalRef,
                                service: res.service,
                                description: res.description,
                                createdOn: res.createdOn,
                                updatedOn: res.updatedOn

                            }

                            totalDataForExport.push(exportDta);
                            this.state.exportArr.push(exportDta)
                        })

                        console.log('current page No:' + pageNo);
                        console.log('total Elements after :' + this.state.exportArr.length);



                    }
                } else {
                    this.state.pageNoOnExport++;
                }

                if (this.state.pageNoOnExport == (this.state.pagenoToExport)) {
                    console.log('export completed');
                    this.setState({
                        exportCompleted: true,
                        contentLoading: false
                    })


                    var exportCompleted = document.getElementById('exportCompleted');
                    exportCompleted.click();

                } else {
                    console.log('export goin on');
                }
                console.log('export count:' + this.state.pageNoOnExport)
            }).catch(error => {
                this.setState({
                    contentLoading: false,
                    errorMessage: 'Something went wrong!'
                })
                if (forExport == true) {
                    this.state.pageNoOnExport++;
                    if (this.state.pageNoOnExport == (this.state.pagenoToExport)) {
                        console.log('export completed');
                        this.setState({
                            exportCompleted: true,
                            contentLoading: false
                        })



                        var exportCompleted = document.getElementById('exportCompleted');
                        exportCompleted.click();

                    } else {
                        console.log('export goin on');
                    }
                }

                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                }
                console.log('export count:' + this.state.pageNoOnExport)

            })
        }
    }
    txnHistory = () => {
        store.dispatch(setTxnReportingData(''));


        var OrderId = '';
        var OrderCreatedOn = '';
        var orderList = [];
        var orderList1 = [];
        var rowList = [];

        this.state.rechargeTxnHistory.map(res => {
            OrderId = res.id == null ? '' : res.id;
            OrderCreatedOn = res.createdOn == null ? '' : moment(res.createdOn).format('DD-MM-YYYY hh:mm:ss')
            var orderObj = {
                orderId: OrderId,
                orderCreatedOn: OrderCreatedOn,
                suborderObjList: []

            }
            if (!orderList.includes(orderObj)) {
                orderList.push(orderObj);
            }
        })
        // console.log('order List:'+JSON.stringify(orderList1));
        console.log('order List size:' + orderList.length);

        orderList.map(order => {

            console.log('order ..' + order.orderId);
            var row = {

                PaymentStatus: '',
                OrderId: '',
                OrderCreatedOn: '',

            }

            row.OrderId = order.orderId;
            row.OrderCreatedOn = order.orderCreatedOn;
            row.PaymentStatus = order.paymentStatus;
            if (!rowList.includes(row)) {
                rowList.push(row);
            }

        })

        console.log('rowList::' + JSON.stringify(rowList));


        store.dispatch(setTxnReportingData(rowList));




    }
    componentWillUnmount() {
    }

    formDateSelect = (event) => {
        console.log(event.target.value);
        this.setState({
            fromDate: event.target.value
        })
        this.loadTxnHistory(0, event.target.value, this.state.toDate, false)
    }
    toDateSelect = (event) => {
        console.log(event.target.value);
        this.setState({
            toDate: event.target.value
        })
        this.loadTxnHistory(0, this.state.fromDate, event.target.value, false)
    }


    resetExportDate = (event) => {
        setTimeout(() => {
            store.dispatch(setTxnReportingData(''));
        }, 200);
    }

    errorMessageCall = (error) => {
        this.setState({
            errorMessage: error
        })
    }
    setStartDate = (date) => {

        this.setState({
            fromDate: date
        })

        var month = String(date.getMonth() + 1);
        var day = String(date.getDate());
        var year = String(date.getFullYear());
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        var startDate = year + '-' + month + '-' + day;

        var toDate = this.state.toDate;
        var month1 = String(toDate.getMonth() + 1);
        var day1 = String(toDate.getDate());
        var year1 = String(toDate.getFullYear());
        if (month1.length < 2) month1 = '0' + month1;
        if (day1.length < 2) day1 = '0' + day1;
        var endDate = year1 + '-' + month1 + '-' + day1;

        this.setState({
            selectedStartDate: startDate,
        })

        // this.setState({
        //     fromDate:startDate,
        //     toDate:endDate
        // })


        // this.loadTxnHistory(0, startDate, endDate, false);

    }
    setEndDate = (date) => {
        this.setState({
            toDate: date
        })

        var month = String(date.getMonth() + 1);
        var day = String(date.getDate());
        var year = String(date.getFullYear());
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        var endDate = year + '-' + month + '-' + day;

        var fromDate = this.state.fromDate;
        var month1 = String(fromDate.getMonth() + 1);
        var day1 = String(fromDate.getDate());
        var year1 = String(fromDate.getFullYear());

        if (month1.length < 2) month1 = '0' + month1;
        if (day1.length < 2) day1 = '0' + day1;
        var startDate = year1 + '-' + month1 + '-' + day1;

        this.setState({
            selectedEndDate: endDate
        })


        // this.setState({
        //     fromDate:startDate,
        //     toDate:endDate
        // })


        // this.loadTxnHistory(0, startDate, endDate, false);

    }

    exportToCSV = () => {
        this.setState({
            showExportModal: true,
            showModalVal: true
        })
        var showModalDiv = document.getElementById('simpleModal');
        showModalDiv.style.display = 'block';
    }



    selectPageNoFromExportModal = (event) => {
        event.preventDefault();

        this.setState({
            pagenoToExport: event.target.value,
            pageNoselected: true
        })


    }

    exportFromModal = (event) => {
        event.preventDefault();
        this.setState({
            showExportModal: false,
            showModalVal: false,
            exportCompleted: '',
            pageNoselected: '',
            exportArr: [],
            pageNoOnExport: 0
        })

        var showModalDiv = document.getElementById('simpleModal');
        showModalDiv.style.display = 'none';

        this.setState({
            contentLoading: true
        })

        console.log('calling for..pageno:' + this.state.pagenoToExport + ':startDate:' +
            this.state.fromDate + ':endDate:' + this.state.toDate + ':export-enable:' + 'true');

        for (let i = 0; i <= (this.state.pagenoToExport - 1); i++) {
            setTimeout(() => {
                this.exportTxnHistory(i, this.state.fromDate, this.state.toDate, true)
            }, 1000)
        }

    }

    test = (event) => {
        event.preventDefault();
        this.loadTxnHistory(0, this.state.selectedStartDate, this.state.selectedEndDate, false);
    }

    closeModalVal = (event) => {
        event.preventDefault();
        this.setState({
            showExportModal: false,
            showModalVal: false,
            exportCompleted: '',
            pageNoselected: '',
            exportArr: [],
            pageNoOnExport: 0
        })

        var showModalDiv = document.getElementById('simpleModal');
        showModalDiv.style.display = 'none';
    }



    render() {
        var recentTxnLoop = ['test', 'test', 'test', 'test', 'test'];
        return (

            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">


                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Account History</h3>

                                                <div class='dateTimePickersearch'>
                                                    Start Date

                                                    <DatePicker
                                                        selected={this.state.fromDate}
                                                        onChange={(date) => this.setStartDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showFullMonthYearPicker


                                                    />
                                                </div>

                                                <div class='dateTimePickersearch'>
                                                    End Date
                                                    <DatePicker
                                                        selected={this.state.toDate}
                                                        onChange={(date) => this.setEndDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showFullMonthYearPicker
                                                    />
                                                </div>
                                                <div class='dateTimePickersearch'>
                                                    <br />
                                                    <button class="dbbtn flaot-left" type="button"
                                                        onClick={this.test}
                                                    >Search</button>
                                                </div>
                                            </div>

                                            <div class="txn-list" id="recntxn">

                                                {
                                                    this.state.contentLoading == false &&
                                                    this.state.orderResp.length > 0 &&
                                                    this.state.orderResp.map((order, index) => (

                                                        <div class="txn-item">
                                                            <div class='txncard grbg'>
                                                                <div class="row">
                                                                    <div class="col-12 col-md-3">
                                                                        <div class="txntype">
                                                                            Id:{order.id}
                                                                        </div>
                                                                        <div class="txntype">
                                                                            SubType:{order.subType}
                                                                        </div>
                                                                    </div>


                                                                    <div class="col-12 col-md-2">
                                                                        <div class="txntype">
                                                                            Balance Before:{order.balanceBefore}
                                                                        </div>
                                                                        <div class="txntype">
                                                                            Amount:{order.amount}
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12 col-md-3">
                                                                        <div class="txntype">
                                                                            Description:{order.description}

                                                                        </div>
                                                                        <div class="txntype">
                                                                            Type:{order.type}
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12 col-md-2">
                                                                        <div class="txntype">
                                                                            Service:{order.service}
                                                                        </div>
                                                                        <div class="txntype">
                                                                            Balance After:{order.balanceAfter}
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-12 col-md-2">
                                                                        <div class="txntype">
                                                                            Date:{moment(order.createdOn).format('DD-MM-YYYY')}
                                                                        </div>
                                                                        <div class="txntype">
                                                                            entityId:{order.entityId}
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>




                                                    ))
                                                }

                                                {
                                                    this.state.errorMessage == '' &&
                                                    this.state.contentLoading == false &&
                                                    this.state.orderResp.length == 0 &&
                                                    <div>
                                                        No records found
                                                    </div>
                                                }

                                                {this.state.errorMessage == '' &&
                                                    this.state.contentLoading == true &&
                                                    // this.props.txnPaginationResponse!='' &&
                                                    recentTxnLoop.map((rctn, index) => (
                                                        <div class="txn-item">
                                                            <div class="txncard">
                                                                <ContentLoader
                                                                    width={350}

                                                                    height={50}
                                                                    speed={1}
                                                                    backgroundColor="#f3f3f3"
                                                                    foregroundColor="#ecebeb"
                                                                    viewBox="0 0 350 50"
                                                                ><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
                                                                    <rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
                                                                    <circle cx="20" cy="20" r="20" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                    )
                                                    )
                                                }



                                                {this.state.errorMessage != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.errorMessage}
                                                    </div>}


                                            </div>


                                            {

                                                this.state.contentLoading == false &&
                                                this.state.orderResp.length > 0 &&
                                                <div class="pager">

                                                    <p>
                                                        {"Showing " + (((this.state.activePage - 1) * 20) + 1) + " to " +
                                                            (this.state.totalElements < (((this.state.activePage - 1) * 20) + this.state.orderResp.length) ?
                                                                this.state.totalElements :
                                                                (((this.state.activePage - 1) * 20) + this.state.orderResp.length))
                                                            + " no records of total " +
                                                            this.state.totalElements}  entries  </p>


                                                    <button class="lbbtn" type="button" onClick={this.exportToCSV}>Export</button>

                                                    {this.state.exportCompleted == true &&
                                                        <CSVLink data={this.state.exportArr}
                                                            filename={"Account-history-" + moment().format('DD-MM-YYYY') + ".csv"}>
                                                            <button id='exportCompleted' hidden={true}
                                                            ></button>
                                                        </CSVLink>
                                                    }
                                                    <Pagination
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={this.state.totalElements / this.state.totalPages}
                                                        totalItemsCount={
                                                            this.state.totalElements}
                                                        pageRangeDisplayed={this.state.totalPages}
                                                        onChange={this.handlePageChangeDefault.bind(this)}
                                                        className="pagination"
                                                        linkClass="page-link"
                                                        itemClass="page-item"
                                                    />
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >


                <div id="simpleModal" class="modal" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Confirm Page for Export</h5>
                            
                            </div>
                            <div class="modal-body">
                                <div class="popup-text">
                                    Select No of pages you want to import
                                    <select class="form-select" id="pageNoDrpDwn"
                                        // aria-label=""
                                        onClick={(e) => this.selectPageNoFromExportModal(e)}>
                                        {this.state.totalPageModalList.map(pageNo => (
                                            <option value={pageNo}
                                            >{pageNo}</option>
                                        ))
                                        }
                                    </select>
                                </div>
                            </div>
                            <div class="modal-footer">
                                {this.state.pageNoselected == true &&
                                    <button class="dbbtn" onClick={this.exportFromModal}>Export</button>
                                }
                                <button class="lbbtn" onClick={this.closeModalVal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>

   

                {/* {this.state.showExportModal == true &&

                    

                    <AccountHistoryModal
                        showModal={this.state.showModalVal}
                        exportDetails={this.state.totalPageModalList}
                        selectPageNoFromExportModal={this.selectPageNoFromExportModal}
                        exportFromModal={this.exportFromModal}
                        pageNoselected={this.state.pageNoselected}
                        closeModal={this.closeModalVal}
                    ></AccountHistoryModal>
                } */}




            </div >
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, deviceInfo, rechargeTxnHistory, callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, clientRole, clientRequesterId, deviceInfo, rechargeTxnHistory, callBackUrl
});

export default connect(mapStateToProps, null)(AccountHistory);
